// ─── Local auth helpers (demo/front-end only) ───────────────────────────────
// This UI runs on mock data (see src/data/mockData.js). Swap these helpers
// and wire real endpoints when a backend is available — the shape mirrors
// the existing billing project's src/server.js (api.get/post/put/delete).

export const getToken = () => localStorage.getItem("physio_token");
export const setToken = (t) => localStorage.setItem("physio_token", t);
export const removeToken = () => localStorage.removeItem("physio_token");
export const getUser = () => {
  try {
    return JSON.parse(localStorage.getItem("physio_user") || "null");
  } catch {
    return null;
  }
};
export const setUser = (u) => localStorage.setItem("physio_user", JSON.stringify(u));
export const removeUser = () => localStorage.removeItem("physio_user");

// ─── Role-based access helpers ───────────────────────────────────────────
// Admins are always treated as having every permission ("super-user"),
// regardless of what's in their `permissions` array. Everyone else only
// sees/can use the modules explicitly granted to them.
export const isAdmin = () => (getUser()?.role || "") === "Admin";

export const hasPermission = (perm) => {
  if (!perm) return true;
  if (isAdmin()) return true;
  const perms = getUser()?.permissions || [];
  return perms.includes(perm);
};
